export default __webpack_public_path__ + "static/fenetre-269f160a2bddf7d5cd970cf34239c2a2.webp";